var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUseLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#0A0A0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61282 8.26147H4.26953V18.923H7.61282V8.26147Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6564 8.03024C16.5331 8.01483 16.4022 8.00713 16.2712 7.99942C14.3993 7.92239 13.3439 9.03168 12.9741 9.50929C12.874 9.64025 12.8278 9.71729 12.8278 9.71729V8.29215H9.63086V18.9537H12.8278H12.9741C12.9741 17.8675 12.9741 16.789 12.9741 15.7028C12.9741 15.1174 12.9741 14.5319 12.9741 13.9465C12.9741 13.2223 12.9202 12.452 13.2823 11.7895C13.5904 11.2349 14.1451 10.9575 14.769 10.9575C16.6179 10.9575 16.6564 12.6292 16.6564 12.7832C16.6564 12.791 16.6564 12.7987 16.6564 12.7987V18.9999H19.9997V12.0437C19.9997 9.66336 18.7902 8.26134 16.6564 8.03024Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94126 6.88253C7.01339 6.88253 7.88253 6.01339 7.88253 4.94126C7.88253 3.86913 7.01339 3 5.94126 3C4.86913 3 4 3.86913 4 4.94126C4 6.01339 4.86913 6.88253 5.94126 6.88253Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseLinkedinIcon);
export default __webpack_public_path__ + "static/media/use-linkedin-icon.d3bb7c0a30b37b8a24752b4d06f7c9e8.svg";
export { ForwardRef as ReactComponent };